/* eslint-disable @typescript-eslint/no-unused-vars */
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason, Switch } from '@mui/material';
import { useState } from 'react';
import { AutoCompleteParceiroListagem } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RelatorioReceber from './Rreceber';
import { RelatorioFinanceiroService } from '../../../shared/services/api/Financeiro/relatorios/ServiceRelatorioFinanceiro';
import { NavBarRelatoriosFinanceiro } from '../../../shared/components/navbar/NavBarRelatoriosFinanceiro';

export const RelatoriosContasReceber: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [uidparceiro, setUidParceiros] = useState('');
  const [situacao, setSituacao] = useState<'todas' | 'vencidas' | 'avencer'>('todas');
  const [semPeriodo, setSemPeriodo] = useState(false);
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs().startOf('month'));
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  const situacaoLabel: Record<typeof situacao, string> = {
    todas: 'Vencidas e a Vencer',
    vencidas: 'Somente Vencidas',
    avencer: 'Somente a Vencer',
  };
  const handleSave = () => {
    setIsLoading(true);
    RelatorioFinanceiroService
      .Rreceber(
        uidparceiro,
        dayjs(dataInicial).format('DD/MM/YYYY'),
        dayjs(dataFinal).format('DD/MM/YYYY'),
        situacao,
        semPeriodo ? 'sim' : 'nao'
      )
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          if (result.length > 0) {
            const periodoTexto = semPeriodo
              ? 'Sem período (todos os lançamentos)'
              : `Período: ${dayjs(dataInicial).format('DD/MM/YYYY')} a ${dayjs(dataFinal).format('DD/MM/YYYY')}`;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            RelatorioReceber(result as any, `${periodoTexto} — ${situacaoLabel[situacao]}`);
          } else {
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);
          }
        }
      });
  };
  const handleSituacao = (event: SelectChangeEvent) => {
    setSituacao(event.target.value as typeof situacao);
  };
  const handleParceiros = (uuidparceiro: string | undefined) => {
    if (uuidparceiro != null) {
      setUidParceiros(uuidparceiro);
    } else {
      setUidParceiros('');
    }
  };

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1} alignContent='center'></Box>
      <Box
        component={Paper}
        sx={{
          width: '100%',
          maxWidth: 600,   // largura máxima
          margin: 'auto',
          padding: 1
        }}
      >
        <NavBarRelatoriosFinanceiro />
        <DialogTitle>Relatório de Contas a Receber</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <Grid container padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompleteParceiroListagem
                  uuidparceiro={handleParceiros}
                />

              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <FormControl fullWidth size='small'>
                  <InputLabel id='situacao-label'>Situação</InputLabel>
                  <Select
                    labelId='situacao-label'
                    label='Situação'
                    value={situacao}
                    onChange={handleSituacao}
                  >
                    <MenuItem value='todas'>Vencidas e a Vencer</MenuItem>
                    <MenuItem value='vencidas'>Somente Vencidas</MenuItem>
                    <MenuItem value='avencer'>Somente a Vencer</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataInicial}
                    onChange={(newValue) => setDataInicial(newValue)}
                    label='Data Inicial'
                    disabled={semPeriodo}
                    slotProps={{
                      textField: {
                        size: 'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataFinal}
                    onChange={(newValue) => setDataFinal(newValue)}
                    label='Data Final'
                    disabled={semPeriodo}
                    slotProps={{
                      textField: {
                        size: 'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={semPeriodo}
                      onChange={(event) => setSemPeriodo(event.target.checked)}
                    />
                  }
                  label="Sem período (todos os lançamentos)"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>

          <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};

